export enum NotificationStatusEnum {
  NEW = 'NEW',
  READ = 'READ',
}
